<div
  class="presentation-overlay"
  [class.visible]="isVisible"
  [style.z-index]="ZIndex.FULLSCREEN"
>
  <!-- Loading State -->
  <div *ngIf="!presentationReady" class="presentation-loading">
    <p>
      {{ "dashboard-presentation.message.preparing-presentation" | translate }}
    </p>
    <app-loading></app-loading>
  </div>

  <div *ngIf="presentationReady" class="presentation-content">
    <div class="presentation-header">
      <div class="logo-container">
        <img
          *ngIf="presentationSettings?.show_sensika_logo"
          [src]="logoUrl"
          alt="Sensika Logo"
        />
        <!-- TODO: Company logo implementation - not implemented yet in the app -->
        <div *ngIf="presentationSettings?.show_company_logo"></div>
      </div>

      <div class="current-page-section">
        <h1
          *ngIf="presentationSettings?.dashboard_title_visible"
          class="presentation-title"
          [style.fontSize.px]="presentationSettings?.dashboard_title_font_size"
          [style.fontWeight]="presentationSettings?.dashboard_title_font_weight"
          [style.color]="
            getThemeColor(presentationSettings?.dashboard_title_color)
          "
        >
          {{ dashboard?.title }}
        </h1>

        <h2
          *ngIf="presentationSettings?.page_title_visible"
          class="page-title"
          [style.fontSize.px]="presentationSettings?.page_title_font_size"
          [style.fontWeight]="presentationSettings?.page_title_font_weight"
          [style.color]="getThemeColor(presentationSettings?.page_title_color)"
        >
          {{ (slides$ | async)?.[currentSlideIndex]?.page.name }}
        </h2>

        <span
          *ngIf="
            presentationSettings?.time_period_visible &&
            (effectivePeriod$ | async) as p
          "
          class="period"
          [style.fontSize.px]="presentationSettings?.time_period_font_size"
          [style.fontWeight]="presentationSettings?.time_period_font_weight"
          [style.color]="getThemeColor(presentationSettings?.time_period_color)"
        >
          {{ p?.startTimestamp * 1000 | date: "dd.MM.yyyy HH:mm" }}
          –
          {{ p?.endTimestamp * 1000 | date: "dd.MM.yyyy HH:mm" }}
        </span>

        <app-dashboard-auto-refresh-counter
          [secondsLeft]="autoReloadSecondsLeft$ | async"
          [cacheEnabled]="cacheEnabled$ | async"
          [reloading]="widgetsReloading"
        ></app-dashboard-auto-refresh-counter>
      </div>

      <div class="progress-section">
        <div
          *ngIf="presentationSettings?.show_controls"
          class="controls-section"
        >
          @if (isAutoMode) {
            <fa-icon
              [icon]="isPlaying ? faCirclePause : faCirclePlay"
              (click)="togglePlayPause()"
              [ngClass]="{ play: !isPlaying, pause: isPlaying }"
            ></fa-icon>
          }
          <fa-icon
            [icon]="faCircleStop"
            (click)="onStopClick()"
            class="stop"
          ></fa-icon>
        </div>

        <div
          *ngIf="presentationSettings?.pagination_visible"
          class="pagination"
          [style.fontSize.px]="presentationSettings?.pagination_font_size"
          [style.fontWeight]="presentationSettings?.pagination_font_weight"
          [style.color]="getThemeColor(presentationSettings?.pagination_color)"
        >
          <ng-container *ngIf="slides$ | async as slides">
            {{ currentSlideIndex + 1 }} / {{ slides.length }}
          </ng-container>
        </div>

        <div
          *ngIf="isAutoMode && showTimer"
          class="autoplay-progress"
          [style.fontSize.px]="presentationSettings?.timer_font_size"
          [style.fontWeight]="presentationSettings?.timer_font_weight"
          [style.color]="getThemeColor(presentationSettings?.timer_color)"
        >
          <svg #progressSvg viewBox="0 0 48 48">
            <circle
              cx="24"
              cy="24"
              r="20"
              stroke-width="4"
              stroke-dasharray="125.6"
              stroke-dashoffset="125.6"
              [attr.stroke]="getThemeColor(presentationSettings?.timer_color)"
            ></circle>
          </svg>
          <span>{{ remainingTime }}s</span>
        </div>
      </div>
    </div>

    <div #slideContainer class="custom-carousel">
      <div
        class="slides-wrapper"
        [style.transform]="'translateX(' + slideOffset + 'px)'"
        [style.transition]="slideTransition"
      >
        <div
          *ngFor="let slide of slides$ | async; trackBy: trackBySlideId"
          class="slide"
        >
          <div class="slide-content">
            <gridstack
              *ngIf="slide.widgets.length > 0"
              [options]="presentationGridConfig"
              class="slide-widgets"
            >
              <gridstack-item
                *ngFor="let widget of slide.widgets; trackBy: trackByWidgetId"
                [options]="getGridItemOptions(widget)"
              >
                <app-widget-card
                  [widget]="widget"
                  [editMode]="false"
                  [viewProperties]="viewProperties"
                  [presentationModeActive]="isVisible"
                  [showLoading]="false"
                >
                </app-widget-card>
              </gridstack-item>
            </gridstack>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
